<template>
  <div class="container no-margin grid-container grid-container--6-6">
    <select-autocomplete
      class="col1"
      placeholder="Ej: 11"
      label="Cód. de área"
      maxlength="4"
      subhint="Ingresá el código de área sin el 0"
      v-model="value.area"
      name="areaTelefono"
      :required="required"
      :items="codigosAreaPopulares"
      :validationError="validationError"
      :scroll-on-focus="scrollOnFocus"
      @input="onInput"
      @focus="trackClick('codigoAreaCelular')"
    />
    <number-input
      class="col2"
      placeholder="Ej: 51279939"
      label="Número"
      name="numeroTelefono"
      maxlength="8"
      subhint="Ingresá el número sin el 15"
      v-model="value.numero"
      :required="required"
      :scroll-on-focus="scrollOnFocus"
      @focus="trackClick('numeroCelular')"
    />
  </div>
</template>

<script>
import { codigosAreaPopulares } from "@/config/constants";
import NumberInput from "@/components/core/NumberInput";
import SelectAutocomplete from "@/components/core/custom/SelectAutocomplete";
import { DO_ADOBE_APPSTARTED } from "../../../../config/constants/action-types";
export default {
  name: "PhoneNumber",
  components: { NumberInput, SelectAutocomplete },
  props: {
    label: String,
    value: Object,
    scrollOnFocus: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      validationError: null,
      checked: false
    };
  },
  methods: {
    onInput() {
      if (this.checked) {
        this.isValid(this.value.area);
      }
    },
    checkValid() {
      this.checked = true;
      return this.isValid(this.value.area);
    },
    isValid(val) {
      // El código de área debe ser numérico
      // El método sólo valida el código de área ya que el número se valida solo
      if (!isNaN(parseFloat(val)) && isFinite(val)) {
        // El valor es numérico
        this.validationError = null;
        return true;
      }
      this.validationError = "El código de área no es válido";
      return false;
    },
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(DO_ADOBE_APPSTARTED, el);
    }
  },
  computed: {
    codigosAreaPopulares() {
      return codigosAreaPopulares;
    }
  }
};
</script>

<style scoped></style>
